import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APISoGhiChiSo = {
  LIST_SO_GHI_CHI_SO: `${BASE_API_URL_CAP_DIEN}/so-ghi-chi-so/list`,
  SYNC_SO_GHI_CHI_SO: `${BASE_API_URL_CAP_DIEN}/so-ghi-chi-so/sync`,
};
